import { AppModule } from 'app/module';
import Template from './template.hbs';
import './styles.scss';

export class ShowMemoButton extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            showMemoButtonContainer: '.m-showMemoButton__container',
        };
    }

    getPropsFromDom() {
        return {
            active: !!this.dom.showMemoButtonContainer,
        };
    }

    domEvents() {
        if (this.dom.showMemoButtonContainer) {
            this.dom.showMemoButtonContainer.addEventListener('click', (e) => {
                if (e) e.stopPropagation();
                this.events.emit('openMemoTab');
            });
        }
    }
}
